/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AuthHttpService } from './services/auth-http.service';
import { ConfigurationHttpService } from './services/configuration-http.service';
import { DynamicApplicationsHttpService } from './services/dynamic-applications-http.service';
import { FormDefinitionHttpService } from './services/form-definition-http.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AuthHttpService,
    ConfigurationHttpService,
    DynamicApplicationsHttpService,
    FormDefinitionHttpService,
    ApiConfiguration,
  ],
})
export class DataAccessApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<DataAccessApiModule> {
    return {
      ngModule: DataAccessApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: DataAccessApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('DataAccessApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575',
      );
    }
  }
}
